import config from "./config.json";

import Chimee from "chimee";
import videoPoster from "./assets/player.jpg";
import hls from "chimee-kernel-hls";

document.addEventListener("DOMContentLoaded", event => {
   //console.log("start...", config);

   const chimee = new Chimee({
      wrapper: "#playerContainer",
      src: config.videoUrl,
      poster: videoPoster,
      controls: true,
      autoplay: true,
      isLive: true,
      kernels: {
         hls
      },
      x5VideoPlayerFullscreen: true,
      x5VideoOrientation: true,
      xWebkitAirplay: true
   });
   chimee.play();
});
